import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EsReqStatusBtn from './EsReqStatusBtn';
import {isMobileOnly} from 'react-device-detect';


const EsReqPriceinfoBlock = styled.div`
    .container {
        padding: 30px 20px;
        border: solid 1px #111111;
        border-bottom-left-radius: 20px;
    }

    .container-stop {
        padding: 20px 20px 30px;
        border: solid 1px #111111;
        border-bottom-left-radius: 20px;
    }

    .status_info {
        height: 40px;
        border-radius: 20px;
        background-color: #f4f4f4;
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
        text-align: center;
        color: #333333;
    }

    .title-block {
        max-height: 56px;
        overflow: hidden;
        width: calc(100% - 110px);
    }
    .title {
        //font-family: NanumPen;
        font-family: 'Nanum Pen Script', cursive;
        font-size: 24px;
        font-weight: normal;
        color: #111111;
        //background-image: linear-gradient(#ffffff 10%,#ffe7ad 80%, #ffffff 10%);
        background: linear-gradient(to bottom, #ffffff 35%, #ffe7ad 21%, #ffe7ad 63%, #ffffff 75%);
    }

    .sub-title {
        font-size: 14px;
        font-weight: normal;
        line-height: 24px;
        color: #333333;
        float: left;
    }

    .sub-title2 {
        font-size: 14px;
        font-weight: normal;
        line-height: 18px;
        color: #333333;
        float: left;
    }

    .margin_t-5 {
        margin-top: 5px;
    }

    .price {
        font-size: 18px;
        font-weight: 500;
        float: right;
    }

    .totla-price {
        font-size: 22px;
    }

    .free {
        font-size: 16px;
    }

    .won {
        font-size: 16px;
    }

    .gray {
        color: #999999;
    }

    .red {
        color: #fd683a;
    }

    .delivery-pay {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.4;
        //margin-top: 5px;
    }

    .stop_info {
        .case {
            padding: 5px 12px 4px;
            height: 24px;
            font-size: 12px;
            font-weight: 500;
            border-radius: 13px;
            border: dashed 1px #fc1c67;
        }

        .case-title {
            font-size: 16px;
            font-weight: 500;
            margin-left: 10px;
            margin-top: -3px;
        }

        .case-info {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.71;
            color: #111111;
        }

        b {
            font-weight: 500;
        }
    }
    
`;

const EsReqPriceDotBlock = styled.div`
    height: 20px;
    .line_dot {
        margin-top: 8px;
        width: calc(100% + 30px);
        height: 1px;
        border-bottom: dashed 1px #111111;
        margin-left: -15px;
    }
    ::before{
        content: "";
        border-top: 1px solid #111111;
        border-left: 1px solid #111111;
        height: 10px;
        width: 10px;
        position: relative;
        -webkit-transform: rotate(135deg);
        -ms-transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        -ms-transform: rotate(135deg);
        transform: rotate(135deg);
        left: -26px;
        top: 14px;
        z-index: 5;
        background-color: #ffffff;
    display: ${props => props.display || 'block'};
    } 

    ::after{
        content: "";
        border-top: 1px solid #111111;
        border-right: 1px solid #111111;
        height: 10px;
        width: 10px;
        position: relative;
        -webkit-transform: rotate(-135deg);
        -ms-transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
        -ms-transform: rotate(-135deg);
        transform: rotate(-135deg);
        left: calc(100% + 15px);
        top: -6px;
        z-index: 5;
        background-color: #ffffff;
        display: ${props => props.display || 'block'};
    } 
`;

const EsReqPriceInfo = ({ esItem, onCloseClick }) => {

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format,es_add_dscnt_price_total, rqst_status, cancel_date_format, es_dlvry_final_pay_type, dday
    } = esItem[0];

    var { esItemDetailInfo, nickname } = useSelector(
        ({ esOrderReducer, userReducer }) => ({
            esItemDetailInfo: esOrderReducer.esItemDetailInfo,
            nickname: userReducer.nickname,
        })
    );

   /*  let date = new Date();
    let date1 = new Date(expr_date);
    date1.setHours(0,0,0,0);
    date.setHours(0,0,0,0);

    let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24) */

    ////console.log("diffDay = " + diffDay);

    const getStatusInfo = () => {
        if(rqst_status==='050101' || rqst_status==='050102' || rqst_status==='050103') {
            return '💬 견적 요청중! 조금만 기다려주세요 :-)';
        } else if (rqst_status==='050104') {
            return '💬 견적 진행중! 곧 완료됩니다 :-)';
        } else if (rqst_status==='050110') {
            return '💬 요청중인 견적서를 취소했어요.';
        } else if (rqst_status==='050111') {
            return '💬 받은 견적서를 취소했어요.';
        } else if (rqst_status === '050105') {
            if(dday < 0) {
                return '💬 견적 주문 기한이 만료되었어요ㅠㅠ';
            } else {
                return '💬 견적서 완료! 체크하고 주문하세요 :-)';
            }
            
        } else if (rqst_status === '050108') {
            return '💬 위와 같은 사유로 견적이 중단되었어요.';
        }
    }

    const getStatusBtn = () => {
        const width = isMobileOnly?"fit-content":"fit-content";
        const marginTop = isMobileOnly?"2px":"78px";
        const borderRadius=isMobileOnly?"14px":"14px";
        const color = (rqst_status === '050105'&&dday>=0)?"#fff":"#333";
        const bgColor = (rqst_status === '050105'&&dday>=0)?"#111":"#fff";
        const borderColor= (rqst_status === '050105'&&dday>=0)?"#111":"#999999";
        const borderStyle= (rqst_status<="050104"?"dashed":"solid")
        const fontSize=isMobileOnly?"12px":"12px";
        const height=isMobileOnly?"24px":"24px";

        //const onClick= (rqst_status === '050105'&&dday>=0)?(()=>handlePckgNmClick()): (()=>{});
        const onClick= (()=>{});

        let textProps = isMobileOnly?{
            "050110":"견적 취소",
            "050111":"견적 취소",
            "050108":"견적 중단",
            "050107":"견적 만료",
            "050105":dday>0?"주문 기한 D-"+dday:"주문기한 만료",
            "050104":"진행중",
            "050103":"요청중",
            "050102":"요청중",
        }:{
            "050110":"견적 취소",
            "050111":"견적 취소",
             "050108":"견적 중단",
             "050107":"견적 만료",
            "050105":dday>0?"주문 기한 D-"+dday:"주문기한 만료",
             "050104":"진행중",
             // "050103":"다시 요청중",
             "050103":"요청중",
             "050102":"요청중",

        };

        // if(!textProps[rqst_status]) textProps[rqst_status] = "진행중";
        if(!textProps[rqst_status]) return null;

        return (<EsReqStatusBtn text={textProps[rqst_status]}
                                width={width}
                                marginTop={marginTop}
                                color={color}
                                bgColor={bgColor}
                                borderColor={borderColor}
                                borderRadius={borderRadius}
                                onClick={onClick}
                                borderStyle={borderStyle}
                                fontSize={fontSize}
                                height={height}
                                fontWeight={'normal'}
                                padding="0 10px"
        />)

    }

    const getEsPriceTitle = () => {
        if(rqst_status === '050110') {
            return (<div className="sub-title gray">총 견적 금액</div>)
        }

        if(es_dlvry_final_pay_type === '025202') {
            return (<div className="sub-title2">총 견적 금액<span className="delivery-pay gray"><br/>(배송비 별도)</span>
            </div>)
        } else {
            return (<div className="sub-title">총 견적 금액</div>)
        }
        
    }
    const getEsPrice = () => {
        if (rqst_status === '050111' || rqst_status === '050105') {

            if(es_pay_price) {
                if(es_dlvry_final_pay_type === '025202') {
                    if(dday < 0 ||rqst_status === '050111' ) {
                        return (<div className="price totla-price gray margin_t-5">{Number(es_pay_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                    } else {
                        return (<div className="price totla-price margin_t-5">{Number(es_pay_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                    }
                } else {
                    if(dday < 0 ||rqst_status === '050111' ) {
                        return (<div className="price totla-price gray">{Number(es_pay_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                    } else {
                        return (<div className="price totla-price">{Number(es_pay_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                    }
                }
                
            } 
        } else if(rqst_status === '050110') {
            return (<div className="price gray">?<span className="won">원</span></div>)
        }

        return (<div className="price">?<span className="won">원</span></div>)
    }

    const getEsDscntPriceTitle = () => {
        if(rqst_status === '050110') {
            return (<div className="sub-title gray">총 할인 금액</div>)
        }

        return (<div className="sub-title">총 할인 금액</div>)
    }

    const getEsDscntPrice = () => {
        if (rqst_status === '050111' || rqst_status === '050105') {

            if(es_dscnt_total_price) {
                if(dday < 0 ||rqst_status === '050111' ) {
                    return (<div className="price red">-{Number(es_dscnt_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                } else {
                    return (<div className="price red">-{Number(es_dscnt_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                }
            } 
        } 

        return (<div className="price gray">?<span className="won">원</span></div>)
    }
    
    const getEsDeliveryPriceTitle = () => {
        if(rqst_status === '050110') {
            return (<div className="sub-title gray">총 배송비</div>)
        }

        if(es_dlvry_final_pay_type === '025202') {
            return (<div className="sub-title2">총 배송비<span className="delivery-pay gray"><br/>(예상 착불 배송비)</span>
            </div>)
        } else {
            return (<div className="sub-title">총 배송비</div>)
        }
    }
    const getDlvryPrice = () => {

        // 선불
        /* if (item.list[0].es_dlvry_final_pay_type === '025201') {
            return (<p className='f-right'>선불 배송비<span> {Number(item.list[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else if (item.list[0].es_dlvry_final_pay_type === '025202') { // 착불
            return (<p className='f-right'>예상 착불 배송비<span> {Number(item.list[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return (<p className='f-right'>무료배송</p>)
        } */
    }

    const getEsDeliveryPrice = () => {
        if (rqst_status === '050111' || rqst_status === '050105') {

            if(es_dlvry_final_pay_type === '025201' || es_dlvry_final_pay_type === '025202') {
                if(es_dlvry_total_price) {
                    if(es_dlvry_final_pay_type === '025202') {
                        if(dday < 0 ||rqst_status === '050111' ) {
                            return (<div className="price  margin_t-5">{Number(es_dlvry_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        } else {
                            return (<div className="price  margin_t-5">{Number(es_dlvry_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        }
                    } else {
                        if(dday < 0 ||rqst_status === '050111' ) {
                            return (<div className="price">{Number(es_dlvry_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        } else {
                            return (<div className="price">{Number(es_dlvry_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        }
                    }
                    
                } 
            }
            else {
                return (<div className="price free">무료배송</div>)
            }
        } 

        return (<div className="price gray">?<span className="won">원</span></div>)
    }

    const getCaseNum = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){
                if(esItemDetailInfo.masterinfo.es_suspend_type === '055401'){
                    return 'CASE 01.';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055402'){
                    return 'CASE 02.';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055403'){
                    return 'CASE 03.';
                }
            }
        }

        return 'CASE'
    }

    const getCaseTitle = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){
                if(esItemDetailInfo.masterinfo.es_suspend_type === '055401'){
                    return '자재 수급 불가';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055402'){
                    return '배송 불가 지역';
                } if(esItemDetailInfo.masterinfo.es_suspend_type === '055403'){
                    return '기타 사유';
                }
            }
        }

        return ''
    }

    const getSuspand = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                let text = "";
                if(esItemDetailInfo.masterinfo.es_suspend_msg !== null && typeof(esItemDetailInfo.masterinfo.es_suspend_msg) === "string" && esItemDetailInfo.masterinfo.es_suspend_msg.length > 0){
                    text = esItemDetailInfo.masterinfo.es_suspend_msg.replace(nickname+'님','<b>' +'“' + nickname + '”님' +  '</b>');
                    text = text.replace(brnd_han,'<b>' +'“' + brnd_han + '”' +  '</b>');
                    text = text.replace(/\n/g,'</br>');
                }
                else {
                    text = esItemDetailInfo.masterinfo.es_suspend_msg;
                }
                //let text = esItemDetailInfo.masterinfo.es_suspend_msg
                return text;
            }
        }

        return "";
    }

    if(esItem === null || esItem === undefined) {
        return <div/>
    }

    return (
        rqst_status === '050108'?
        <EsReqPriceinfoBlock>
            <div className="container-stop">
                <div className="stop_info">
                    <div className="clearfix">
                        <div className="f-left"><span className="case pink">{getCaseNum()}</span></div>
                        <div className="case-title pink f-left">{getCaseTitle()}</div>
                    </div>
                    <EsReqPriceDotBlock className="margin_b-30">
                    <div className="line_dot" />
                    </EsReqPriceDotBlock>
                    <div className="case-info">
                        <div  dangerouslySetInnerHTML={{ __html: getSuspand() }} />
                    </div>
                </div>
                
            </div>
            
            <div className="status_info margin_t-20">{getStatusInfo()}</div>
            
        </EsReqPriceinfoBlock>
        :
        <EsReqPriceinfoBlock>
            <div className="status_info margin_b-30">{getStatusInfo()}</div>
            <div className="container">
                <div className="clearfix margin_b-20">
                    <div className="title-block f-left"><span className="title">{pckg_nm}</span></div>
                    <div className="f-right">{getStatusBtn()}</div>
                </div>
                <div className="clearfix margin_b-10">
                    {getEsPriceTitle()}
                    {getEsPrice()}
                </div>
                
                
                <EsReqPriceDotBlock className="margin_b-30">
                    <div className="line_dot" />
                </EsReqPriceDotBlock>
                <div className="clearfix margin_b-20">
                    <div className="sub-title">총 상품 금액</div>
                    <div className="price">{es_prdct_total_price&&Number(es_prdct_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                </div>
                <div className="clearfix margin_b-20">
                    {getEsDscntPriceTitle()}
                    {getEsDscntPrice()}
                </div>
                <div className="clearfix ">
                    {getEsDeliveryPriceTitle()}
                    {getEsDeliveryPrice()}
                </div>
            </div>
            
        </EsReqPriceinfoBlock>
    );
};

export default EsReqPriceInfo;
